import { AppDataLocalTax } from '../../content/app-data-ltc-data';
import { AppDataProcessSteps } from '../../content/app-data-ltc-process-steps';
import { PageHeaderSg, TimelineSteps } from '@scts-ui/component-library';
import { LtcAppealType, ProcessType } from '@scts/models';

import {
  replaceDevLinkWithConfig,
  useTitleService,
} from '@scts/utilities';
import { useEffect, useState } from 'react';
import { Tabs, Tab, Button } from 'react-bootstrap';
import ProcessOpen from '../../components/process-open-close-buttons/process-open-html';
import ProcessClose from '../../components/process-open-close-buttons/process-close-html';
import { STORAGE_ACCOUNT, FRONT_DOOR_URL } from '../../../config';

export const Apply = () => {
  useTitleService('Make an Appeal: Local Taxation Chamber');
  const [ndrs, setNdrs] = useState<LtcAppealType[]>([]);
  const [cts, setCts] = useState<LtcAppealType[]>([]);
  const [water, setWater] = useState<LtcAppealType[]>([]);
  const [visitorLevy, setVisitorLevy] = useState<LtcAppealType[]>([]);
  const [additionalGuidance, setAdditionalGuidance] = useState<LtcAppealType[]>([]);
  const [additionalGuidanceSubsections, setAdditionalGuidanceSubsections] = useState<LtcAppealType[]>([]);
  const [showNdrProcess, setShowNdrProcess] = useState(
    new Array(AppDataLocalTax.appealTypesNdr.items.length).fill(false)
  );
  const [showCtProcess, setShowCtProcess] = useState(
    new Array(AppDataLocalTax.appealTypesCt.items.length).fill(false)
  );
  const [showWaterProcess, setShowWaterProcess] = useState(
    new Array(AppDataLocalTax.appealTypesWater.items.length).fill(false)
  );
   const [showVisitorLevyProcess, setShowVisitorLevyProcess] = useState(
    new Array(AppDataLocalTax.appealTypesVisitorLevy.items.length).fill(false)
  );

  useEffect(() => {
    AppDataLocalTax.appealTypesNdr.items.map((item) => {
      item.links.map((link) => {
        if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
          link.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            link.url
          );
        }
      });
    });

    AppDataLocalTax.appealTypesWater.items.map((item) => {
      item.links.map((link) => {
        if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
          link.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            link.url
          );
        }
      });
    });

    AppDataLocalTax.appealTypesCt.items.map((item) => {
      item.links.map((link) => {
        if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
          link.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            link.url
          );
        }
      });
    });

    AppDataLocalTax.appealTypesVisitorLevy.items.map((item) => {
      item.links.map((link) => {
        if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
          link.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            link.url
          );
        }
      });
    });

    AppDataLocalTax.additionalGuidanceSubsections.items.map((item) => {
      item.links.map((link) => {
        if (STORAGE_ACCOUNT && FRONT_DOOR_URL !== undefined) {
          link.url = replaceDevLinkWithConfig(
            FRONT_DOOR_URL,
            STORAGE_ACCOUNT,
            link.url
          );
        }
      });
    });

    setNdrs(AppDataLocalTax.appealTypesNdr.items);
    setCts(AppDataLocalTax.appealTypesCt.items);
    setWater(AppDataLocalTax.appealTypesWater.items);
    setVisitorLevy(AppDataLocalTax.appealTypesVisitorLevy.items);
    setAdditionalGuidance(AppDataLocalTax.additionalGuidance.items);
    setAdditionalGuidanceSubsections(AppDataLocalTax.additionalGuidanceSubsections.items);
  }, [FRONT_DOOR_URL, STORAGE_ACCOUNT]);

  const openNdrProcess = (i: number) => {
    const newArray = showNdrProcess.map((item, index) => {
      if (index === i) {
        item = !item;
      }
      return item;
    });

    setShowNdrProcess(newArray);
  };

  const openCtProcess = (i: number) => {
    const newArray = showCtProcess.map((item, index) => {
      if (index === i) {
        item = !item;
      }
      return item;
    });

    setShowCtProcess(newArray);
  };

  const openWaterProcess = (i: number) => {
    const newArray = showWaterProcess.map((item, index) => {
      if (index === i) {
        item = !item;
      }
      return item;
    });

    setShowWaterProcess(newArray);
  };

  const openVisitorLevyProcess = (i: number) => {
    const newArray = showVisitorLevyProcess.map((item, index) => {
      if (index === i) {
        item = !item;
      }
      return item;
    });

    setShowVisitorLevyProcess(newArray);
  };

  const addLinkInBody = (body: string) => {
    const [before, after] = body.split('{{LINK}}');

    return (
      <div
        className="upper-trib"
        style={{ marginBottom: '1.5rem' }}
      >
        {before}
        <a
          rel="noreferrer"
          target={'_blank'}
          href="https://www.saa.gov.uk/ndp/make-ndp/"
        >
         Scottish Assessors Association <i className="bi bi-box-arrow-up-right"></i>
        </a>

        {after}
      </div>
    )
  };

  return (
    <>
      <PageHeaderSg headerText={'Make An Appeal'} />
      <h2>Taking of oral evidence from persons located overseas in tribunal proceedings</h2>
      <p className="pt-4">
        It would be helpful if parties who wish to lead oral evidence from witnesses located outside of the UK in tribunal proceedings could contact the tribunal to make staff aware of their intention to lead such evidence.
      </p>
      <p>
        It would also be helpful if parties could please confirm whether the proposed witness is a citizen or a resident in that country or not, so that the tribunal is made aware of the reason why the party requests that oral evidence is given from that country.
      </p>
      <p>
        There are 11 different types of appeals across four areas.
      </p>
      <div className="apply-tabs pt-4">
        <Tabs defaultActiveKey="ndr" id="uncontrolled-tab-example">
          <Tab
            eventKey="ndr"
            title={'Non-Domestic Rate Appeals (' + ndrs.length + ') '}
          >
            <div className="card">
              <div className="card-body">
                <ul>
                  {ndrs.map((item, index) => (
                    <li key={index} className="pb-3 pt-3">
                      <h2>{item.title}</h2>
                      <pre>{addLinkInBody(item.body)}</pre>
                      {/* fudge for UT */}
                      {item.id === 'ndr-appeal' && (
                        <div
                          className="upper-trib"
                          style={{ marginBottom: '1.5rem' }}
                        >
                          <a
                            rel="noreferrer"
                            target={'_blank'}
                            href="https://www.scotcourts.gov.uk/the-courts/tribunal-locations/the-upper-tribunal-for-scotland"
                          >
                            Upper Tribunal for Scotland <i className="bi bi-box-arrow-up-right"></i>
                          </a>
                        </div>
                      )}
                      {/* end fudge for UT */}

                      <div className="d-flex justify-content-between">
                        {item.id !== 'ndr-upper' && (
                          <div aria-live="polite">
                            {!showNdrProcess[index] && (
                              <Button
                                data-testid={'ndr-element' + index}
                                variant="link"
                                className="d-flex"
                                onClick={() => openNdrProcess(index)}
                              >
                                <ProcessOpen processType={item.processType} />
                              </Button>
                            )}
                            {showNdrProcess[index] && (
                              <Button
                                variant="link"
                                className="d-flex"
                                onClick={() => openNdrProcess(index)}
                              >
                                <ProcessClose processType={item.processType} />
                              </Button>
                            )}
                          </div>
                        )}

                        <div className="apply-links d-flex flex-column">
                          {item.links &&
                            item.links.map((link, index) => (
                              <a
                                key={index + 10}
                                href={link.url}
                                target="_blank"
                                className="pt-2"
                                rel="noreferrer"
                              >
                                <span className="visually-hidden">
                                  {item.title + ' - '}{' '}
                                </span>
                                {link.text}{' '}
                                <i className="bi bi-box-arrow-up-right"></i>
                              </a>
                            ))}
                        </div>
                      </div>
                      <div aria-live="polite">
                        {showNdrProcess[index] && item.id === 'ndr-appeal' && (
                          <TimelineSteps
                            steps={AppDataProcessSteps.ndrBanding.steps}
                          />
                        )}

                        {showNdrProcess[index] &&
                          item.id === 'ndr-complaint' && (
                            <TimelineSteps
                              steps={AppDataProcessSteps.ndrComplaint.steps}
                            />
                          )}

                        {showNdrProcess[index] && item.id === 'ndr-penalty' && (
                          <TimelineSteps
                            steps={AppDataProcessSteps.ndrPenalty.steps}
                          />
                        )}
                      </div>
                      {ndrs.length !== index + 1 ? <hr /> : ''}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="ct"
            title={'Council Tax Appeals  (' + cts.length + ') '}
          >
            <div className="card">
              <div className="card-body">
                <ul>
                  {cts.map((item, index) => (
                    <li key={index} className="pb-3 pt-3">
                      <h2>{item.title}</h2>
                      <pre>{item.body}</pre>
                      {item.id === 'ct-banding' && (
                        <div
                          className="upper-trib"
                          style={{ marginBottom: '1.5rem' }}
                        >
                          <p>Information on detailed time limits in relation to Council Tax banding proposals can be found on the website of the <a
                              rel="noreferrer"
                              target={'_blank'}
                              href="https://www.saa.gov.uk/council-tax/council-tax-proposals/"
                            >Scottish Assessors Association <i className="bi bi-box-arrow-up-right"></i>
                            </a>
                            .
                          </p>
                        </div>
                      )}
                      <div className="d-flex justify-content-between">
                        <div aria-live="polite">
                          {!showCtProcess[index] && (
                            <Button
                              data-testid={'ct-element' + index}
                              variant="link"
                              className="d-flex"
                              onClick={() => openCtProcess(index)}
                            >
                              <ProcessOpen processType={'Appeal'} />
                            </Button>
                          )}

                          {showCtProcess[index] && (
                            <Button
                              variant="link"
                              className="d-flex"
                              onClick={() => openCtProcess(index)}
                            >
                              <ProcessClose processType={'Appeal'} />
                            </Button>
                          )}
                        </div>
                        <div className="apply-links d-flex flex-column">
                          {item.links &&
                            item.links.map((link, index) => (
                              <a
                                key={index + 10}
                                href={link.url}
                                target="_blank"
                                className="pt-2"
                                rel="noreferrer"
                              >
                                <span className="visually-hidden">
                                  {item.title + ' - '}{' '}
                                </span>
                                {link.text}{' '}
                                <i className="bi bi-box-arrow-up-right"></i>
                              </a>
                            ))}
                        </div>
                      </div>
                      <div aria-live="polite">
                        <>
                          {/* last minute changes mean need to do a big switch statement.. could make this better but not sure its worth the effort */}
                          {showCtProcess[index] && item.id === 'ct-banding' && (
                            <TimelineSteps
                              steps={AppDataProcessSteps.ctBanding.steps}
                            />
                          )}
                          {showCtProcess[index] &&
                            item.id === 'ct-liability' && (
                              <TimelineSteps
                                steps={AppDataProcessSteps.ctLiability.steps}
                              />
                            )}
                          {showCtProcess[index] &&
                            item.id === 'ct-completion' && (
                              <TimelineSteps
                                steps={AppDataProcessSteps.ctCompletion.steps}
                              />
                            )}

                          {showCtProcess[index] && item.id === 'ct-invalid' && (
                            <TimelineSteps
                              steps={AppDataProcessSteps.ctBandingInValid.steps}
                            />
                          )}

                          {showCtProcess[index] &&
                            item.id === 'ct-reduction' && (
                              <TimelineSteps
                                steps={AppDataProcessSteps.ctReduction.steps}
                              />
                            )}

                          {showCtProcess[index] && item.id === 'ct-water' && (
                            <TimelineSteps
                              steps={AppDataProcessSteps.ctWater.steps}
                            />
                          )}

                          {showCtProcess[index] && item.id === 'ct-penalty' && (
                            <TimelineSteps
                              steps={AppDataProcessSteps.ctPenalty.steps}
                            />
                          )}
                        </>
                      </div>

                      {cts.length !== index + 1 ? <hr /> : ''}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="water"
            title={'Water Charges Appeals  (' + water.length + ') '}
          >
            <div className="card">
              <div className="card-body">
                <ul>
                  {water.map((item, index) => (
                    <li key={index} className="pb-3 pt-3">
                      <h2>{item.title}</h2>
                      <pre>{item.body}</pre>
                      <div className="d-flex justify-content-between">
                        <div aria-live="polite">
                          {!showWaterProcess[index] && (
                            <Button
                              variant="link"
                              className="d-flex"
                              onClick={() => openWaterProcess(index)}
                            >
                              <ProcessOpen processType="Appeal" />
                            </Button>
                          )}

                          {showWaterProcess[index] && (
                            <Button
                              variant="link"
                              onClick={() => openWaterProcess(index)}
                              className="d-flex"
                            >
                              <ProcessClose processType="Appeal" />
                            </Button>
                          )}
                        </div>
                        <div className="apply-links d-flex flex-column">
                          {item.links &&
                            item.links.map((link, index) => (
                              <a
                                key={index + 10}
                                href={link.url}
                                target="_blank"
                                className="pt-2"
                                rel="noreferrer"
                              >
                                <span className="visually-hidden">
                                  {item.title + ' - '}{' '}
                                </span>
                                {link.text}{' '}
                                <i className="bi bi-box-arrow-up-right"></i>
                              </a>
                            ))}
                        </div>
                      </div>
                      <div aria-live="polite">
                        <>
                          {showWaterProcess[index] &&
                            item.id === 'ct-water' && (
                              <TimelineSteps
                                steps={AppDataProcessSteps.ctWater.steps}
                              />
                            )}
                        </>
                      </div>
                      {water.length !== index + 1 ? <hr /> : ''}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="visitor-levy"
            title={'Visitor Levy Appeals (' + visitorLevy.length + ') '}
          >
            <div className="card">
              <div className="card-body">
                <ul>
                  {visitorLevy.map((item, index) => (
                    <li key={index} className="pb-3 pt-3">
                      <h2>{item.title}</h2>
                      <pre>{item.body}</pre>
                      <div className="d-flex justify-content-between">
                        <div aria-live="polite">
                          {!showVisitorLevyProcess[index] && (
                            <Button
                              variant="link"
                              className="d-flex"
                              onClick={() => openVisitorLevyProcess(index)}
                            >
                              <ProcessOpen processType="Appeal" />
                            </Button>
                          )}

                          {showVisitorLevyProcess[index] && (
                            <Button
                              variant="link"
                              onClick={() => openVisitorLevyProcess(index)}
                              className="d-flex"
                            >
                              <ProcessClose processType="Appeal" />
                            </Button>
                          )}
                        </div>
                        <div className="apply-links d-flex flex-column">
                          {item.links &&
                            item.links.map((link, index) => (
                              <a
                                key={index + 10}
                                href={link.url}
                                target="_blank"
                                className="pt-2"
                                rel="noreferrer"
                              >
                                <span className="visually-hidden">
                                  {item.title + ' - '}{' '}
                                </span>
                                {link.text}{' '}
                                <i className="bi bi-box-arrow-up-right"></i>
                              </a>
                            ))}
                        </div>
                      </div>
                      <div aria-live="polite">
                        <>
                          {showVisitorLevyProcess[index] &&
                            item.id === 'vl-appeal' && (
                              <TimelineSteps
                                steps={AppDataProcessSteps.ctVisitorLevy.steps}
                              />
                            )}
                        </>
                      </div>
                      {visitorLevy.length !== index + 1 ? <hr /> : ''}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="ag"
            title={'Additional Guidance (' + additionalGuidance.length + ') '}
          >
            <div className="card">
              <div className="card-body">
                <ul>
                  {additionalGuidance.map((item, index) => (
                    <li key={index} className="pb-3 pt-3">
                      <h2>{item.title}</h2>
                      <pre>{item.body}</pre>
                      {item.id === 'ag' && (
                        <div
                          className="upper-trib"
                          style={{ marginBottom: '1.5rem' }}
                        >
                          {additionalGuidanceSubsections.map((item, index) => (
                            <div key={index}>
                              <h4>{item.title}</h4>
                              <div
                                className="additonal-guidance-links d-flex flex-column"
                                style={{ marginBottom: '1.5rem' }}
                              >
                              <ul>
                                {item.links.map((link, index) => (
                                  <li>
                                    <a className={'pt-2'} target={'_blank'} href={link.url} key={index} rel="noreferrer">
                                      {link.text}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>                       
                          </div>
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default Apply;
